import { IDeliveryFee, IProducts, IPromo } from './product.interface';

interface mockData {
  products: IProducts[];
  promo?: IPromo[];
  delivery_fee: IDeliveryFee[];
}

const virtualCardData: mockData = {
  products: [
    {
      card_fee: 5,
      commission_calc_mode: '%',
      commission_value: 1.5,
      confection: [],
      decription: 'Najlepszy prezent na Święta.Opis',
      delivery_fee: 0,
      delivery_free_quantity: 0,
      file: '',
      idproducts: 28215,
      label: null,
      name: 'Wirtualna Karta Podarunkowa',
      price: 0,
      product_category: 'ECV_ISS',
      product_type: '35',
      reg_link: null,
      slug: 'wirtualna-karta-podarunkowa',
      status: 'ACTIVE',
      type_mrk: null,
      vat: 0.23,
      analyticsData: {},
    },
  ],
  delivery_fee: [
    {
      idproducts: 1000002,
      product_category: 'AD',
      name: 'Liczba pkt. dostaw',
      decription: 'Liczba pkt. dostaw',
      product_type: 112,
      price: null,
      status: 'ACTIVE',
      created: '2020-10-02 10:17:11',
    },
  ],
};
const eVoucherData: mockData = {
  products: [
    {
      idproducts: 29182,
      product_category: 'ECV_ISS',
      name: 'Voucher 50',
      label: 'Evoucher sample label',
      vat: 0.23,
      decription: 'Evoucher',
      reg_link: 'asdasdasdasd',
      product_type: '25',
      price: 50,
      status: 'ACTIVE',
      commission_calc_mode: null,
      commission_value: null,
      delivery_fee: 0,
      delivery_free_quantity: 0,
      card_fee: 0,
      type_mrk: null,
      slug: 'evoucher-50',
      file: '',
      confection: [],
      analyticsData: {},
    },
  ],
  promo: [
    {
      idproducts: 1000001,
      product_category: 'MRK',
      name: 'Pakiet promocji',
      decription: 'Pakiet promocji',
      product_type: 111,
      price: 0,
      status: 'ACTIVE',
      created: '2020-05-06 09:29:51',
    },
  ],
  delivery_fee: [
    {
      idproducts: 1000002,
      product_category: 'AD',
      name: 'Liczba pkt. dostaw',
      decription: 'Liczba pkt. dostaw',
      product_type: 112,
      price: 0,
      status: 'ACTIVE',
      created: '2020-05-06 09:29:51',
    },
  ],
};
const contractData = {
  default: [
    {
      amount_from: '0',
      card_fee: '6.9',
      commission_calc_mode: 'A',
      commission_value: '25',
      contract_id: 'default',
      currency_code: 'PLN',
      delivery_fee: '35',
      delivery_free_quantity: '0',
      price: '0',
      product_id: '28248',
    },
    {
      amount_from: '357.15',
      card_fee: '6.9',
      commission_calc_mode: '%',
      commission_value: '7',
      contract_id: 'default',
      currency_code: 'PLN',
      delivery_fee: '35',
      delivery_free_quantity: '0',
      price: '0',
      product_id: '28248',
    },
  ],
  individual: null,
};
class MockData {
  private readonly mockedData;

  constructor(data) {
    this.mockedData = data;
  }

  public getMockData = () => this.mockedData;
}

export const getEVoucherData = new MockData(eVoucherData).getMockData();
export const getVirtualCardData = new MockData(virtualCardData).getMockData();
export const getMockedContractData = contractData;

export default MockData;
